import { render } from "./CompetitiveTrends.vue?vue&type=template&id=5ec24003"
import script from "./CompetitiveTrends.vue?vue&type=script&lang=js"
export * from "./CompetitiveTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__